/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: phone_number.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  AddProgramPhoneNumberRequest,
  AddProgramPhoneNumberResponse,
  CreatePhoneNumberRequest,
  CreatePhoneNumberResponse,
  DeletePhoneNumberRequest,
  DeletePhoneNumberResponse,
  ListPhoneNumbersRequest,
  ListPhoneNumbersResponse,
  ListProgramPhoneNumbersRequest,
  ListProgramPhoneNumbersResponse,
  RemoveProgramPhoneNumberRequest,
  RemoveProgramPhoneNumberResponse,
  UpdatePhoneNumberRequest,
  UpdatePhoneNumberResponse,
} from '../types/phone_number';

export const createPhoneNumberService = (transport: Transport) => ({
  async listProgramPhoneNumbers(
    request: ListProgramPhoneNumbersRequest,
    options: RequestOptions = {},
  ): Promise<ListProgramPhoneNumbersResponse> {
    const { organization_id, ...params } = request;
    const url = getApiPath(API_METHODS.PhoneNumberService.ListProgramPhoneNumbers, {
      organization_id,
    });
    return transport.get<ListProgramPhoneNumbersResponse>(url, { params, ...options });
  },

  async listPhoneNumbers(
    request: ListPhoneNumbersRequest,
    options: RequestOptions = {},
  ): Promise<ListPhoneNumbersResponse> {
    const url = getApiPath(API_METHODS.PhoneNumberService.ListPhoneNumbers);
    return transport.get<ListPhoneNumbersResponse>(url, { params: request, ...options });
  },

  async createPhoneNumber(
    request: CreatePhoneNumberRequest,
    options: RequestOptions = {},
  ): Promise<CreatePhoneNumberResponse> {
    const url = getApiPath(API_METHODS.PhoneNumberService.CreatePhoneNumber);
    return transport.post<CreatePhoneNumberResponse>(url, request, options);
  },

  async updatePhoneNumber(
    request: UpdatePhoneNumberRequest,
    options: RequestOptions = {},
  ): Promise<UpdatePhoneNumberResponse> {
    const { phone_number_id, ...body } = request;
    const url = getApiPath(API_METHODS.PhoneNumberService.UpdatePhoneNumber, { phone_number_id });
    return transport.post<UpdatePhoneNumberResponse>(url, body, options);
  },

  async deletePhoneNumber(
    request: DeletePhoneNumberRequest,
    options: RequestOptions = {},
  ): Promise<DeletePhoneNumberResponse> {
    const { phone_number_id } = request;
    const url = getApiPath(API_METHODS.PhoneNumberService.DeletePhoneNumber, { phone_number_id });
    return transport.delete<DeletePhoneNumberResponse>(url, options);
  },

  async addProgramPhoneNumber(
    request: AddProgramPhoneNumberRequest,
    options: RequestOptions = {},
  ): Promise<AddProgramPhoneNumberResponse> {
    const { organization_id, program_id, ...body } = request;
    const url = getApiPath(API_METHODS.PhoneNumberService.AddProgramPhoneNumber, {
      organization_id,
      program_id,
    });
    return transport.post<AddProgramPhoneNumberResponse>(url, body, options);
  },

  async removeProgramPhoneNumber(
    request: RemoveProgramPhoneNumberRequest,
    options: RequestOptions = {},
  ): Promise<RemoveProgramPhoneNumberResponse> {
    const { organization_id, program_id, phone_number_id } = request;
    const url = getApiPath(API_METHODS.PhoneNumberService.RemoveProgramPhoneNumber, {
      organization_id,
      program_id,
      phone_number_id,
    });
    return transport.delete<RemoveProgramPhoneNumberResponse>(url, options);
  },
});

export type PhoneNumberService = ReturnType<typeof createPhoneNumberService>;
